var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1765_12649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 18,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0024 11.1808V7.99943C15.9994 5.07269 13.8861 2.57475 11.0003 2.08696V0.99651C11.0003 0.443996 10.5524 -0.00390625 9.99992 -0.00390625C9.4474 -0.00390625 8.9995 0.443996 8.9995 0.99651V2.08696C6.11369 2.57475 4.00038 5.07269 3.99742 7.99943V11.1808C2.80119 11.6037 2.00015 12.7331 1.99658 14.0019V16.0028C1.99658 16.5553 2.44448 17.0032 2.997 17.0032H6.13831C6.6119 18.7459 8.19402 19.9554 9.99992 19.9554C11.8058 19.9554 13.3879 18.7459 13.8615 17.0032H17.0028C17.5553 17.0032 18.0032 16.5553 18.0032 16.0028V14.0019C17.9997 12.7331 17.1986 11.6037 16.0024 11.1808ZM5.99825 7.99943C5.99825 5.78937 7.78986 3.99776 9.99992 3.99776C12.21 3.99776 14.0016 5.78937 14.0016 7.99943V11.0007H5.99825V7.99943ZM9.99992 18.0036C9.2894 17.9993 8.63445 17.6185 8.2792 17.0032H11.7206C11.3654 17.6185 10.7104 17.9993 9.99992 18.0036ZM16.0024 15.0023H3.99742V14.0019C3.99742 13.4494 4.44532 13.0015 4.99783 13.0015H15.002C15.5545 13.0015 16.0024 13.4494 16.0024 14.0019V15.0023Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1765_12649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2b10a4f504ccdcf83140a98575c6d5cd.svg";
export { ForwardRef as ReactComponent };